import * as React from 'react'
import { useCallback, useEffect, useReducer, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import GridContainer from '../../../../grid/GridContainer'
import GridItem from '../../../../grid/GridItem'
import Card from '../../../../card/Card'
import CardHeader from '../../../../card/CardHeader'
import CardBody from '../../../../card/CardBody'
import CustomInput from '../../../../input/CustomInput'
import CardFooter from '../../../../card/CardFooter'
import Button from '../../../../button/RegularButton'
import { timeout } from '../../../../../App'
import Snackbar from '../../../../snackbar/Snackbar'
import { AddAlert } from '@material-ui/icons'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import { CountryDropdown } from 'react-country-region-selector'
import MenuItem from '@material-ui/core/MenuItem'
import styles from 'assets/jss/dorm-app/customSelectStyle.js'
import { useParams } from 'react-router-dom'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import CustomDateInput from '../../../../input/CustomDateInput'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import { initialNotificationState } from '../../../../utils/state/ApplicationState'
import Badge from '../../../../badge/Badge'
import UniversitySelect from './UniversitySelect'
import { createDateFromString, stringifyDates } from '../../../../utils/DateUtils'
import { getApiUrl } from '../../../../../api/api'

const useStyles = makeStyles(styles)

function moveReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'create':
      return {
        ...state,
      }
    case 'success':
      return {
        ...initialMoveState,
        success: true,
      }
    case 'error':
      return {
        ...state,
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialMoveState = {
  success: false,
  newRoom: '',
  moveDate: null,
}

function tenantReducer(state, action) {
  switch (action.type) {
    case 'field':
      return {
        ...state,
        [action.field]: action.value,
      }
    case 'fetch':
      return {
        ...action.value,
        birthday: createDateFromString(action.value.birthday),
        movedOut: createDateFromString(action.value.movedOut),
        movedIn: createDateFromString(action.value.movedIn),
      }
    case 'success':
      return {
        success: true,
      }

    case 'error':
      return {
        ...state,
        success: false,
        errorMessage: action.errorMessage,
      }

    default:
      break
  }
  return state
}

const initialTenantState = {
  success: false,
  errorMessage: '',
  name: '',
  surname: '',
  email: '',
  telNumber: '',
  birthday: null,
  gender: '',
  nationality: '',
  university: '',
  studyField: '',
  room: '',
  movedIn: null,
  movedOut: null,
  note: '',
  extensionStatus: '',
  tenantId: '',
  deposit: '',
  extension: '',
  sublet: '',
}

export default function EditTenantPage() {
  const classes = useStyles()

  const { tenantId } = useParams()

  const [tenantState, dispatchTenant] = useReducer(tenantReducer, initialTenantState)
  const [moveState, dispatchMove] = useReducer(moveReducer, initialMoveState)
  const [departureDate, setDepartureDate] = useState(null)

  const [rentals, setRentals] = useState([])
  const [proceeding, setProceeding] = useState(true)

  const [notification, setNotification] = useState(initialNotificationState)

  const fetchRentals = useCallback(() => {
    getApiUrl()
      .get(`/admin/tenants/${tenantId}/rentals`)
      .then(function(response) {
        setProceeding(false)
        setRentals(response.data)
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [tenantId])

  const fetchTenant = useCallback(() => {
    getApiUrl()
      .get(`/admin/tenants/${tenantId}`)
      .then(function(response) {
        setProceeding(false)
        dispatchTenant({ type: 'fetch', value: response.data })
      })
      .catch(function(error) {
        setProceeding(false)
        console.log(error)
      })
  }, [tenantId])

  useEffect(() => {
    setProceeding(true)
    fetchTenant()
    fetchRentals()
  }, [fetchTenant, fetchRentals])

  const handleTerminationSubmit = (e) => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }
    e.preventDefault()

    if (departureDate === null) {
      setNotification({
        open: true,
        message: 'Bitte einen Auszugsdatum auswählen.',
        color: 'danger',
      })
      setTimeout(function() {
        setNotification(initialNotificationState)
      }, 2000)
      return
    }

    const body = {
      moveOutDate: departureDate,
      tenantId: tenantId,
    }

    setProceeding(true)
    getApiUrl()
      .post(`/admin/departures/terminations`, stringifyDates(body))
      .then(function() {
        fetchTenant()
        fetchRentals()
        setProceeding(false)
        setNotification({
          open: true,
          message: 'Kündigung wurde erstellt.',
          color: 'success',
        })
      })
      .catch(function(error) {
        console.log(error)
        setProceeding(false)
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const submitMove = (e) => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }
    e.preventDefault()

    dispatchMove({ type: 'create' })

    getApiUrl()
      .post(`/admin/tenants/${tenantId}/move`, stringifyDates(moveState))
      .then(function() {
        fetchTenant()
        fetchRentals()
        setNotification({
          open: true,
          message: 'Bewohner erfolgreich umgezogen.',
          color: 'success',
        })
        dispatchMove({ type: 'success' })
      })
      .catch(function(error) {
        dispatchMove({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  const submitEdit = (e) => {
    // const options = {
    //   headers: { Authorization: `Bearer ${user.token}` },
    // }
    e.preventDefault()

    getApiUrl()
      .put(`/admin/tenants/${tenantId}`, stringifyDates(tenantState))
      .then(function() {
        fetchTenant()
        fetchRentals()
        setNotification({
          open: true,
          message: 'Bewohner aktualisiert',
          color: 'success',
        })
      })
      .catch(function(error) {
        dispatchTenant({ type: 'error', errorMessage: error })
        setNotification({
          open: true,
          message: error.response.data.message,
          color: 'danger',
        })
      })
      .finally(
        setTimeout(function() {
          setNotification(initialNotificationState)
        }, timeout),
      )
  }

  if (proceeding) {
    return (
      <Backdrop open={proceeding}>
        <CircularProgress color="inherit"/>
      </Backdrop>
    )
  }

  return (
    <div className={classes.container}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Bewohner bearbeiten</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Vorname"
                    id="name"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.name,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'name',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Nachname"
                    id="surname"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.surname,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'surname',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Email"
                    id="email"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.email,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'email',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Telefonnummer"
                    id="telNumber"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.telNumber,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'telNumber',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={2}>
                  <FormControl fullWidth className={classes.selectFormControl}>
                    <InputLabel htmlFor="gender" className={classes.selectLabel}>
                      Geschlecht
                    </InputLabel>
                    <Select
                      MenuProps={{
                        className: classes.selectMenu,
                      }}
                      classes={{
                        select: classes.select,
                      }}
                      value={tenantState.gender}
                      onChange={(e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'gender',
                          value: e.currentTarget.getAttribute('data-value'),
                        })
                      }
                      inputProps={{
                        name: 'gender',
                        id: 'gender',
                      }}>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="MALE">
                        Männlich
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="FEMALE">
                        Weiblich
                      </MenuItem>
                      <MenuItem
                        classes={{
                          root: classes.selectMenuItem,
                          selected: classes.selectMenuItemSelected,
                        }}
                        value="DIVERSE">
                        Divers
                      </MenuItem>
                    </Select>
                  </FormControl>
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomDateInput
                    labelText="Geburt"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.birthday,
                      onChange: (date) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'birthday',
                          value: date,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CountryDropdown
                    value={tenantState.nationality}
                    id="nationality"
                    defaultOptionLabel={'Staatsangehörigkeit'}
                    priorityOptions={['DE', 'IT', 'AT', 'ES']}
                    onChange={(val) =>
                      dispatchTenant({
                        type: 'field',
                        field: 'nationality',
                        value: val,
                      })
                    }
                    classes={`MuiSelect-root MuiInputBase-input`}
                    style={{
                      width: '100%',
                      margin: '47px 0 0 0',
                      position: 'relative',
                      verticalAlign: 'unset',
                      font: 'inherit',
                      fontWeight: '400',
                      cursor: 'pointer',
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                  <CustomInput
                    labelText="Studienfach"
                    id="studyField"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.studyField,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'studyField',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <UniversitySelect state={tenantState} dispatch={dispatchTenant}/>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Kaution"
                    id="deposit"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.deposit,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'deposit',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={2}>
                  <CustomInput
                    labelText="Zimmer"
                    id="room"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenantState.room,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'room',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomDateInput
                    labelText="Einzug"
                    id="movedIn"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenantState.movedIn,
                      onChange: (date) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'movedIn',
                          value: date,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomDateInput
                    labelText="Auszug"
                    id="movedOut"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.movedOut,
                      onChange: (date) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'movedOut',
                          value: date,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <CustomInput
                    labelText="Notiz der Verwaltung"
                    id="note"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: tenantState.note,
                      type: 'text',
                      multiline: true,
                      rows: 5,
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'note',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button
                color="primary"
                onClick={(e) => {
                  submitEdit(e)
                }}>
                Daten aktualisieren
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Verlängerungen</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Verlängerungen"
                    id="extension"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenantState.extension,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'extension',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Untermiete"
                    id="sublet"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      disabled: true,
                      value: tenantState.sublet,
                      type: 'text',
                      onChange: (e) =>
                        dispatchTenant({
                          type: 'field',
                          field: 'sublet',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                {tenantState.extensionStatus === 'PROCESSING' ? (
                  <GridItem xs={12} sm={12} md={4}>
                    <div style={{ margin: '35px 0 0 70px' }}>
                      <Badge color="info">Verlängerungsbewerbung gestellt</Badge>
                    </div>
                  </GridItem>
                ) : null}
                {tenantState.extensionStatus === 'CREATED' ? (
                  <GridItem xs={12} sm={12} md={4}>
                    <div style={{ margin: '35px 0 0 70px' }}>
                      <Badge color="warning">Verlängerungsbewerbung offen</Badge>
                    </div>
                  </GridItem>
                ) : null}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Anmietungen</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Zimmer</TableCell>
                        <TableCell>Einzug</TableCell>
                        <TableCell>Auszug</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rentals.map((rental) => (
                        <TableRow key={rental.room}>
                          <TableCell>{rental.room}</TableCell>
                          <TableCell>{rental.movedIn}</TableCell>
                          <TableCell>{rental.movedOut}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </GridItem>
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Umzug</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomInput
                    labelText="Neues Zimmer"
                    id="newRoom"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: moveState.newRoom,
                      type: 'text',
                      onChange: (e) =>
                        dispatchMove({
                          type: 'field',
                          field: 'newRoom',
                          value: e.currentTarget.value,
                        }),
                    }}
                  />
                </GridItem>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomDateInput
                    labelText="Umzugsdatum"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: moveState.moveDate,
                      onChange: (date) =>
                        dispatchMove({
                          type: 'field',
                          field: 'moveDate',
                          value: date,
                        }),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button
                color="primary"
                onClick={(e) => {
                  submitMove(e)
                }}>
                umziehen
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>Kündigung</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12} sm={12} md={4}>
                  <CustomDateInput
                    labelText="Neues Auszugsdatum"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      value: departureDate,
                      onChange: (date) => setDepartureDate(date),
                    }}
                  />
                </GridItem>
              </GridContainer>
            </CardBody>
            <CardFooter>
              <Button
                color="primary"
                onClick={(e) => {
                  handleTerminationSubmit(e)
                }}>
                Kündigen
              </Button>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
      <Snackbar
        place="br"
        color={notification.color}
        icon={AddAlert}
        message={notification.message}
        open={notification.open}
        closeNotification={() =>
          setNotification({
            open: false,
            message: '',
            color: '',
          })
        }
        close
      />
    </div>
  )
}
